export const SearchByFleetNameTab = 'SearchFleet';
export const SearchByObjectNameTab = 'SearchObject';
